import { Typography, TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FlexCenVer } from '@/UI/styles';
import { I18N_KEYS } from '@/language/keys';
import { SealCheckIcon } from '@/UI/Icons/SealCheckIcon';
import { color } from '@/colors';

type VerifiedSealProps = {
  textVariant?: TypographyProps['variant'];
  textColor?: TypographyProps['color'];
  iconSize?: number;
};

export const VerifiedSeal = ({
  textVariant = 'body-xs-rg',
  textColor = color.White100,
  iconSize = 16,
}: VerifiedSealProps) => {
  const { t } = useTranslation();

  return (
    <FlexCenVer sx={{ gap: 0.5 }}>
      <SealCheckIcon width={iconSize} height={iconSize} />
      <Typography variant={textVariant} color={textColor}>
        {t(I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.VERIFIED_BY_FIGMA)}
      </Typography>
    </FlexCenVer>
  );
};
